module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/027-fbb3147f3d57475858fb108c82aa43bd.jpg";